var _style, _g, _defs, _ellipse, _rect, _path, _path2, _g2, _path3, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330.5 129.3",
    style: {
      enableBackground: "new 0 0 330.5 129.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EAEAEA;}\n\t.st1{fill:#F7F7F7;}\n\t.st2{fill:#9C9C9C;}\n\t.st3{fill:#CB2026;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{display:none;clip-path:url(#XMLID_17_);fill:#A2A3A3;}\n\t.st6{clip-path:url(#XMLID_17_);fill:#8C8C8C;}\n\t.st7{clip-path:url(#XMLID_17_);fill:#C1C1C0;}\n\t.st8{clip-path:url(#XMLID_17_);fill:#58595B;}\n\t.st9{clip-path:url(#XMLID_17_);}\n\t.st10{fill:#2E3192;}\n\t.st11{clip-path:url(#XMLID_17_);fill:#353535;}\n\t.st12{fill:#353535;}\n\t.st13{fill:#4D4B4C;}\n\t.st14{display:none;fill:#FFF450;}\n\t.st15{fill:#8C8C8C;}\n\t.st16{fill:#9B9A9A;}\n\t.st17{fill:#58595B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_36_",
    x: 330.6,
    y: 0.6,
    className: "st0",
    width: 165.2,
    height: 92.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_40_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_252_",
    x: 385.6,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_250_",
    x: 385.6,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_53_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_249_",
    x: 468.2,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_247_",
    x: 468.2,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_246_",
    x: 440.7,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_244_",
    x: 440.7,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_243_",
    x: 413.1,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_241_",
    x: 413.1,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_37_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_240_",
    x: 358,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_227_",
    x: 358,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_38_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_228_",
    x: 330.5,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_209_",
    x: 330.5,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_208_",
    x: 330.5,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_43_",
    x: 330.6,
    y: 50,
    className: "st2",
    width: 165.2,
    height: 13.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_207_",
    x: 330.6,
    y: 51.2,
    className: "st3",
    width: 165.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_205_",
    x: 330.6,
    y: 51.2,
    className: "st3",
    width: 165.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_204_",
    x: 330.6,
    y: 51.2,
    className: "st3",
    width: 165.2,
    height: 11.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LOGO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st4",
    d: "M351.1,53.3c-0.2,0-0.5,0.1-0.7,0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.1,0-0.3,0.1-0.4,0.1 c-0.1,0-0.3,0.1-0.4,0.1c-0.3,0.1-0.5,0.2-0.7,0.4c-0.1,0.1-0.3,0.2-0.4,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.3 c0,0.3,0.2,0.6,0.5,0.8c0.1,0.1,0.2,0.1,0.3,0.2c0.3,0.2,0.6,0.3,0.8,0.5c0.3,0.1,0.6,0.3,0.9,0.4c0.3,0.1,0.6,0.2,0.9,0.3 c0.1,0,0.2,0.1,0.3,0.1c0.3,0.1,0.6,0.2,0.8,0.3c0.2,0.1,0.3,0.1,0.5,0.2c0.2,0.1,0.4,0.2,0.5,0.3c0.1,0.1,0.2,0.2,0.3,0.3 c0.1,0.1,0.1,0.2,0.1,0.4c0,0.1,0,0.2-0.1,0.3c-0.2,0.3-0.5,0.4-0.7,0.6c-0.4,0.2-0.9,0.3-1.3,0.5c-0.3,0.1-0.5,0.1-0.8,0.2 c-0.3,0.1-0.5,0.1-0.8,0.2c-0.3,0.1-0.5,0.1-0.8,0.2c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.2,0-0.3,0.1c-0.2,0-0.4,0.1-0.6,0.1 c-0.2,0-0.4,0.1-0.6,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0.1-0.1,0.1c0.2,0,0.8-0.1,2-0.2c0.4-0.1,0.9-0.1,1.3-0.2 c0.5-0.1,1.1-0.2,1.6-0.3c0.2,0,0.3-0.1,0.5-0.1c0.1,0,0.2-0.1,0.3-0.1c0.4-0.1,1.1-0.4,1.3-0.4c0.6-0.3,1-0.5,1.2-0.9 c0.1-0.2,0.1-0.4,0.1-0.5c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.2-0.5-0.4-0.7-0.5c-0.1,0-0.2-0.1-0.2-0.1 c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.4-0.1-0.7-0.2-1.1-0.4c-0.2-0.1-0.4-0.1-0.6-0.2c-0.1,0-0.2-0.1-0.3-0.1 c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.2-0.3-0.4c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2-0.1,0.3-0.1c0.3-0.1,0.6-0.1,0.9-0.2 c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.3,0-0.6-0.2-0.9c-0.1-0.1-0.1-0.2-0.2-0.3 c-0.1-0.1-0.2-0.2-0.3-0.4c0-0.1-0.1-0.1-0.1,0C352.6,52.8,352.4,53,351.1,53.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st4",
    d: "M371.2,56L371.2,56L371.2,56l0.1-0.1l0,0l0,0l0,0l0,0l0,0l0-0.1l0,0l0,0l0-0.1l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0.1l0,0.1l0,0.1l0,0.1l0,0l0,0l0,0l0,0.1l0,0l0,0l0,0l0,0l0,0v0l0,0l0,0v0l0,0l0,0l0,0l0,0l0,0h0l0,0 l-0.3,0h0l0,0h0l0,0l0,0h-0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0L371.2,56L371.2,56L371.2,56L371.2,56L371.2,56L371.2,56 L371.2,56z M369.6,57.2C369.6,57.2,369.7,57.2,369.6,57.2c0.2,0,0.2,0.1,0.1,0.3c0,0-0.1,0.1-0.1,0.1l0,0c0,0,0,0.1,0,0.1l0,0 c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2,0,0.4,0c0.3,0,0.5,0,0.7-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0.1,0.2,0.2 c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.2l0,0c0.1,0.1,0.2,0,0.2-0.1c0-0.2-0.1-0.4-0.2-0.5 c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2,0-0.3c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2-0.1c0.2,0,0.3-0.1,0.5-0.1 c0.1,0,0.2-0.1,0.3,0c0.1,0.1,0,0.3,0,0.4c-0.1,0.2-0.1,0.4-0.1,0.5c0,0.2,0,0.3,0.1,0.5c0.1,0.1,0.2,0.2,0.3,0.1 c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.1-0.4,0.2-0.5c0-0.1,0.1-0.3,0.2-0.4c0-0.1,0.1-0.2,0.1-0.2 c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.3,0.3,0.3c0.2,0.1,0.4-0.1,0.5-0.3 c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.1,0.1,0.1,0.2c0,0.3,0.1,0.6,0.1,1 c0,0.1,0,0.2,0.1,0.4l0,0.2c0,0.1,0,0.2,0,0.2c0,0.2,0.1,0.3,0.1,0.5c0,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.4,0.1,0.5-0.1 c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2c0-0.3-0.1-0.6-0.1-0.8c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.5,0.1-0.8c0-0.3,0-0.7,0-1 c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.2,0-0.4,0.1-0.6,0.2 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.4,0.4-0.6,0.7c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3 c-0.1-0.1-0.1-0.2-0.2-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.3,0c-0.1,0.1-0.1,0.2-0.1,0.3 c0,0.1,0,0.2,0,0.3c0,0.2,0,0.5-0.1,0.7c0,0.1-0.1,0.2-0.1,0.3c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0 c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.4 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0-0.2,0.1 c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.2-0.2,0.3c-0.2,0.3-0.4,0.7-0.6,1.1c0,0.1-0.1,0.1-0.1,0.2 c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0,0.2,0,0.3C369.7,57.1,369.6,57.1,369.6,57.2 L369.6,57.2z M356.3,59.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.1-0.1-0.2,0-0.4 c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.2,0,0.3-0.1c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.3,0-0.4c0-0.4,0-0.8,0-1.1c0-0.1,0-0.2-0.1-0.2 c-0.2-0.1-0.2-0.2-0.2-0.4c0-0.1,0-0.2,0-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.3-0.1,0.4-0.1 c0.1,0,0.3,0,0.4-0.1c0.1,0,0.3,0,0.4-0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0 c0.1,0,0.3,0,0.4,0c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.3,0.3,0.1,0.5c-0.2,0.2-0.5,0.1-0.7,0.1c-0.2,0-0.4,0-0.6,0 c-0.2,0-0.4,0-0.5,0c-0.2,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2,0,0.2 c0.1,0.2,0.3,0.1,0.4,0.1c0.3,0,0.6-0.1,0.8-0.1c0.1,0,0.3,0,0.4,0c0.2,0,0.3,0,0.5,0c0.1,0,0.3,0,0.4,0c0.2,0,0.3,0.1,0.5,0.2 c0.2,0.1,0.2,0.3,0.1,0.5c0,0.1,0,0.2-0.1,0.2c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.4,0-0.6,0c-0.3,0-0.6,0.1-0.9,0.1 c-0.2,0-0.4,0.1-0.5,0.1c-0.1,0-0.3,0-0.4,0.1l0,0l0,0l0,0l0,0c0,0.1-0.1,0.3,0,0.4l0,0h0c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.4,0 c0.3,0,0.6,0,0.9-0.1c0.2,0,0.4,0,0.6,0c0.3,0,0.6,0,0.8-0.1c0.2,0,0.3,0,0.5-0.1c0.2-0.1,0.3-0.2,0.5-0.3 c0.2-0.1,0.5-0.2,0.7-0.3c0.3-0.1,0.6-0.3,0.9-0.4c0.2-0.1,0.4-0.2,0.7-0.3c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.3-0.1,0.2-0.2 c0-0.1-0.1-0.1-0.2-0.1c-0.2,0-0.8,0-1.1,0.1c-0.5,0.1-0.6,0.2-0.8,0c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.2,0.1-0.4,0.1-0.4 c0.2-0.2,0.7-0.2,0.9-0.2c0.1,0,0.2,0,0.4,0c0.2,0,0.3,0,0.5,0c0.1,0,0.3,0,0.4,0c0.2,0,0.4,0,0.5,0.1c0.1,0,0.1,0,0.2,0.1 c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1l0,0c0,0.1-0.1,0.1-0.1,0.1 c-0.2,0.2-0.5,0.2-0.7,0.3c-0.1,0-0.2,0.1-0.4,0.2c-0.3,0.2-0.7,0.3-1,0.4c-0.3,0.1-0.6,0.2-0.8,0.4c-0.1,0-0.2,0.1-0.2,0.2 c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0,0.6-0.1c0.2,0,0.4,0,0.6-0.1c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.6,0 c0.2,0,0.4,0,0.6,0l0,0l0.1,0c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.3,0.2-0.5c0.1-0.2,0.1-0.4,0.2-0.6c0,0,0-0.1,0-0.1 c0.1-0.2,0.2-0.5,0.3-0.7c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.2-0.2,0.3-0.1c0.1,0.1,0.2,0.2,0.2,0.3 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.5,0.2 c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0.1-0.3,0.1-0.4 c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2,0,0.3,0c0,0,0,0,0,0c0,0.1,0.1,0.2,0.1,0.2 c0,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.2,0,0.4c0,0.4,0,0.9-0.1,1.3c0,0.2-0.1,0.5-0.1,0.7c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.1-0.1,0.2 c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.1-0.1-0.2,0c0,0.1,0,0.1-0.1,0.2 c0,0.1-0.1,0.3-0.1,0.4c0,0.1-0.2,0.5-0.4,0.3c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0-0.3,0.1 c-0.2,0-0.4,0.1-0.5,0.1c-0.1,0-0.2,0-0.4,0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0-0.4,0.1c-0.2,0-0.4,0-0.6,0.1 c-0.2,0-0.3,0-0.4,0.1c-0.1,0-0.2,0-0.4,0c-0.2,0-0.4,0-0.6,0c-0.3,0-0.6,0-1,0c-0.1,0-0.2,0-0.2-0.1c0,0,0-0.1,0-0.1l0,0l0,0 l0,0l0,0h0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c-0.1,0.2-0.3,0.3-0.5,0.3L356.3,59.2 M387.5,57.5c-0.4,0-0.9,0.1-1.3,0.1 c-0.1,0-0.4,0-0.5-0.1c-0.4-0.2,0.9-0.6,1-0.7c0.4-0.2,1.3-0.4,1.3-0.4s0.8-0.2,0.8-0.6c0-0.5-0.5-0.8-0.9-0.9 c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0-0.2,0-0.4,0c-0.2,0-0.4,0-0.7,0c-0.2,0-0.7,0-0.8,0.3c0,0.1-0.2,0.4-0.1,0.6 c0.1,0.1,0.4,0.1,0.6,0.1c0.3,0,0.5-0.1,0.8-0.1c0.2,0,0.4-0.1,0.6,0.1c0.2,0.2-0.3,0.3-0.4,0.4c-0.4,0.2-0.8,0.3-1.1,0.4 c-0.4,0.1-0.7,0.3-1.1,0.4c-0.2,0.1-0.3,0.2-0.5,0.3l-0.1,0l-0.4,0l-0.4,0c-0.3,0-0.6,0-0.9,0c-0.1,0-0.4,0-0.5-0.1 c-0.3-0.2-0.1-0.6,0.1-0.8c0.2-0.2,0.4-0.4,0.7-0.6c0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.3-0.1,0.4-0.1c0,0,0,0.1,0.1,0.1 c0,0,0.3-0.1,0.4-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.5,0 c-0.1,0-0.2,0-0.4,0.1c-0.2,0.1-0.4,0.1-0.5,0.2c-0.2,0.1-0.5,0.3-0.6,0.5c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.3-0.2,0.4 c-0.1,0.4-0.1,0.9,0.1,1.3c0.1,0.3,0.3,0.5,0.6,0.7c0.3,0.2,0.7,0.3,1.1,0.2c0.2,0,0.3-0.1,0.4-0.1c0.2-0.1,0.3-0.1,0.4-0.2 c0,0,0.3-0.2,0.4-0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.3,0.1,0.4,0.1c0.4,0,0.8,0.1,1.2,0.1 c0.3,0,0.6,0,0.9,0c0.2,0,0.4,0,0.6-0.1c0.5-0.1,0.9-0.2,1.5-0.4c0.2-0.1,0.4-0.2,0.5-0.4c-0.1,0-0.1-0.1-0.2-0.1 c-0.4-0.2-0.9-0.2-1.3-0.1c-0.2,0-0.4,0-0.6,0.1C387.7,57.5,387.6,57.5,387.5,57.5 M380.7,57.9c0-0.1,0-0.1,0-0.2 c-0.1-0.1-0.2-0.3-0.4-0.3c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.1,0.1-0.2,0.2c-0.1,0.2-0.1,0.4,0,0.5c0.2,0.2,0.6,0.2,0.8,0 C380.6,58.2,380.7,58.1,380.7,57.9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "BG2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_272_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_303_",
    x: 165.3,
    y: 0.6,
    className: "st0",
    width: 165.2,
    height: 92.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_299_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_202_",
    x: 220.3,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_200_",
    x: 220.3,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_295_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_199_",
    x: 302.9,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_130_",
    x: 302.9,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_291_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_128_",
    x: 275.4,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_126_",
    x: 275.4,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_287_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_98_",
    x: 247.8,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_96_",
    x: 247.8,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_283_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_95_",
    x: 192.7,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_90_",
    x: 192.7,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_279_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_89_",
    x: 165.2,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_84_",
    x: 165.2,
    y: -4.9,
    className: "st1",
    width: 0.5,
    height: 102
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_278_",
    x: 165.3,
    y: 50,
    className: "st2",
    width: 165.2,
    height: 13.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_273_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_85_",
    x: 165.3,
    y: 51.2,
    className: "st3",
    width: 165.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_83_",
    x: 165.3,
    y: 51.2,
    className: "st3",
    width: 165.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_82_",
    x: 165.3,
    y: 51.2,
    className: "st3",
    width: 165.2,
    height: 11.3
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "VLAK"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M157.4,90.8H-48.5c-6.9,0-12.5-5.1-12.5-11.5V37.9c0-6.3,5.6-11.5,12.5-11.5h205c4.7,0,4.9,1.9,7,4.9 c2.2,3.3,9,32,9.5,40.2l0,5.3C173,91.8,166.9,90.8,157.4,90.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible",
      fill: "#A2A3A3"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_8_",
    className: "st5",
    cx: 74.7,
    cy: 34.7,
    rx: 35,
    ry: 30.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_9_",
    x: -75,
    y: 85.7,
    className: "st6",
    width: 270.3,
    height: 74.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st7",
    d: "M166.3,32.3H-57.6c-7.5,0-13.6-4.1-13.6-9.1V-9.6c0-5,6.1-9.1,13.6-9.1h222.9 c5.1,0,5.4,1.5,7.6,3.8c2.4,2.6,9.8,25.4,10.3,31.9l0,4.2C183.1,33.1,176.5,32.3,166.3,32.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st8",
    d: "M174.9,77L156,71.2c-0.4-0.1-0.7-0.2-1.1-0.2c-4.7-0.7-9.5-1-14.3-1H-66 c-3.6,0-6.5-2.6-6.5-5.9V44.2c0-3.3,2.9-5.9,6.5-5.9h247.9c4,0,7,3.3,6.4,6.9l-4.9,27.2C182.7,76,178.7,78.2,174.9,77z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_",
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_81_",
    className: "st10",
    d: "M142.2,78.7H-70.9v-5h212.7l9.4,0.5c2.5,0.2,6.1,1.2,8.8,2.1l8,2.4H142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_79_",
    className: "st3",
    d: "M142.2,78.7H-70.9v-5h212.7l9.4,0.5c2.5,0.2,6.1,1.2,8.8,2.1l8,2.4H142.2z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st11",
    d: "M175.6,74.7l-23-7.1c-0.7,0-1.2-0.5-1.2-1.1V42.2c0-0.6,0.5-1.1,1.2-1.1h22.8 c0.7,0,1.2,0.5,1.2,1.1l0.2,31.4C176.8,74.2,176.3,74.7,175.6,74.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st12",
    d: "M76.3,67.6h-30c-0.6,0-1.1-0.5-1.1-1.1V42.2c0-0.6,0.5-1.1,1.1-1.1h30c0.6,0,1.1,0.5,1.1,1.1 v24.3C77.4,67.1,76.9,67.6,76.3,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st12",
    d: "M40.8,67.6h-30c-0.6,0-1.1-0.5-1.1-1.1V42.2c0-0.6,0.5-1.1,1.1-1.1h30c0.6,0,1.1,0.5,1.1,1.1 v24.3C41.9,67.1,41.4,67.6,40.8,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st12",
    d: "M147.3,67.6h-18.5c-0.6,0-1.1-0.5-1.1-1.1V42.2c0-0.6,0.5-1.1,1.1-1.1h18.5 c0.6,0,1.1,0.5,1.1,1.1v24.3C148.3,67.1,147.8,67.6,147.3,67.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_70_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st12",
    d: "M123.1,88.8H81.9c-0.8,0-1.4-0.6-1.4-1.4V37c0-0.8,0.6-1.4,1.4-1.4h41.2 c0.8,0,1.4,0.6,1.4,1.4v50.5C124.5,88.2,123.8,88.8,123.1,88.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_10_",
    x: 102,
    y: 35.6,
    width: 1,
    height: 53.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st13",
    d: "M119,71.2h-10.8c-1.1,0-1.9-0.9-1.9-1.9V42.9c0-1.1,0.9-1.9,1.9-1.9H119 c1.1,0,1.9,0.9,1.9,1.9v26.4C121,70.3,120.1,71.2,119,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st13",
    d: "M96.6,71.2H85.9c-1.1,0-1.9-0.9-1.9-1.9V42.9c0-1.1,0.9-1.9,1.9-1.9h10.8 c1.1,0,1.9,0.9,1.9,1.9v26.4C98.6,70.3,97.7,71.2,96.6,71.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_69_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st12",
    d: "M5.8,88.8h-41.2c-0.8,0-1.4-0.6-1.4-1.4V37c0-0.8,0.6-1.4,1.4-1.4H5.8 c0.8,0,1.4,0.6,1.4,1.4v50.5C7.2,88.2,6.6,88.8,5.8,88.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_67_",
    x: -15.3,
    y: 35.6,
    width: 1,
    height: 53.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    className: "st13",
    d: "M1.8,71.2H-9c-1.1,0-1.9-0.9-1.9-1.9V42.9c0-1.1,0.9-1.9,1.9-1.9H1.8c1.1,0,1.9,0.9,1.9,1.9 v26.4C3.7,70.3,2.8,71.2,1.8,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    className: "st13",
    d: "M-20.6,71.2h-10.8c-1.1,0-1.9-0.9-1.9-1.9V42.9c0-1.1,0.9-1.9,1.9-1.9h10.8 c1.1,0,1.9,0.9,1.9,1.9v26.4C-18.7,70.3-19.5,71.2-20.6,71.2z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_239_",
    x: 156.8,
    y: 28.7,
    className: "st14",
    width: 25.1,
    height: 15.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_210_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_216_",
    className: "st15",
    points: "173.4,40.6 162.2,37.5 162.2,34 173.4,37.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_212_",
    className: "st15",
    d: "M173.1,49.3h-1.7c-0.8,0-1.4-0.6-1.4-1.4v-9.3c0-0.8,0.6-1.4,1.4-1.4h1.7 c0.8,0,1.4,0.6,1.4,1.4v9.3C174.5,48.7,173.8,49.3,173.1,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_211_",
    className: "st15",
    d: "M162.1,37.6h-1.5c-0.7,0-1.2-0.5-1.2-1.2v-1.2c0-0.7,0.5-1.2,1.2-1.2h1.5 c0.7,0,1.2,0.5,1.2,1.2v1.2C163.3,37,162.8,37.6,162.1,37.6z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "PODLAHA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_230_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_238_",
    x: 330.6,
    y: 90.2,
    className: "st16",
    width: 165.2,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_237_",
    x: 330.5,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_236_",
    x: 354.1,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_235_",
    x: 424.9,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_234_",
    x: 401.3,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_233_",
    x: 377.7,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_232_",
    x: 448.5,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_231_",
    x: 472.1,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_226_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_77_",
    x: 165.3,
    y: 94.5,
    className: "st12",
    width: 330.5,
    height: 34.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_52_",
    x: 165.3,
    y: 94.5,
    className: "st12",
    width: 330.5,
    height: 34.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_217_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_225_",
    x: 165.3,
    y: 90.2,
    className: "st16",
    width: 165.2,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_224_",
    x: 165.3,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_223_",
    x: 188.9,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_222_",
    x: 259.7,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_221_",
    x: 236.1,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_220_",
    x: 212.5,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_219_",
    x: 283.3,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_218_",
    x: 306.9,
    y: 90.2,
    className: "st17",
    width: 12.3,
    height: 4.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetro);
export default __webpack_public_path__ + "static/media/metro.3bf02a088fff94535d9d7354265101ed.svg";
export { ForwardRef as ReactComponent };